<template>
	<div class="statistic">
		<div class="view-title">
			<translate>Operation Statistic</translate>
		</div>
		<div class="view-content">
			<div class="csos-tabs">
				<el-tabs type="card" :active-name="activeTabName" @tab-click="onChangeTab">
					<div class="panel">
						<div class="panel-header">
							<div v-if="statistic.type != 'overview'" class="clearfix panel-search">
								<div class="dropdown">
									<el-select :disabled="loading" v-model="statistic.dataLen" @change="onChangeDateLen">
										<el-option :label="attrText.within7Day" :value="7"></el-option>
										<el-option :label="attrText.within30Day" :value="30"></el-option>
										<el-option :label="attrText.within90Day" :value="90"></el-option>
									</el-select>
								</div>
							</div>

							<!-- 筛选栏 -->
							<div v-if="statistic.type === 'overview'" class="filter-bar">
								<div class="flex items-center">
									<span class="filter-label">成员</span>
									<el-select class="filter-select" v-model="summaryFilter.account_id" filterable clearable>
										<el-option v-for="(item, index) in filterList.memberList" :label="item.name" :value="item.id" :key="index"> </el-option>
									</el-select>
								</div>
								<div class="flex items-center">
									<span class="filter-label">资源类型</span>
									<el-select class="filter-select" v-model="summaryFilter.resource_type" filterable clearable>
										<el-option label="Linux（SSH）" value="terminal"></el-option>
										<el-option label="Windows（RDP）" value="rdp"></el-option>
										<el-option label="MySQL" value="mysql"></el-option>
										<el-option label="SQL Server" value="mssql"></el-option>
										<el-option label="PostgreSQL" value="postgresql"></el-option>
										<el-option label="Oracle" value="oracle"></el-option>
									</el-select>
								</div>
								<div class="flex items-center">
									<span class="filter-label">工作组</span>
									<el-select class="filter-select" v-model="summaryFilter.project_id" filterable clearable>
										<el-option v-for="(item, index) in filterList.workGroupList" :label="item.name" :value="item.id" :key="index"> </el-option>
									</el-select>
								</div>
								<div class="flex items-center">
									<span class="filter-label">集群</span>
									<el-select class="filter-select" v-model="summaryFilter.network_id" filterable clearable>
										<el-option v-for="(item, index) in filterList.clusterList" :label="item.name" :value="item.id" :key="index"> </el-option>
									</el-select>
								</div>
								<div class="flex items-center">
									<span class="filter-label">资源</span>
									<el-select class="filter-select" v-model="summaryFilter.resource_id" filterable clearable popper-class="resource-select">
										<el-option v-for="(item, index) in filterList.resourceList" :label="item.name" :value="item.id" :key="index">
											<p>{{ item.name }}</p>
											<p>{{ item.ip_address }}</p>
										</el-option>
									</el-select>
								</div>
								<el-date-picker v-model="filterTimes" type="daterange" placeholder="选择日期范围" :picker-options="pickerOptions" @change="changeTimes"> </el-date-picker>
								<el-button @click="handleExport" class="export-btn">导出PDF</el-button>
							</div>

							<div v-if="statistic.type === 'resource'">
								<el-button :disabled="loading" :type="statistic.chart === 'networkproject' ? 'primary' : ''" @click="onChangeChart('networkproject')"><translate>All</translate></el-button>
								<el-button :disabled="loading" :type="statistic.chart === 'network' ? 'primary' : ''" @click="onChangeChart('network')"><translate>Cluster</translate></el-button>
								<el-button :disabled="loading" :type="statistic.chart === 'project' ? 'primary' : ''" @click="onChangeChart('project')"><translate>WorkGroup</translate></el-button>
							</div>

							<div v-if="statistic.type === 'company'">
								<el-button :disabled="loading" :type="statistic.chart === 'connect' ? 'primary' : ''" @click="onChangeChart('connect')"><translate>Numbers Of Connections</translate></el-button>
								<el-button :disabled="loading" :type="statistic.chart === 'dateLen' ? 'primary' : ''" @click="onChangeChart('dateLen')"><translate>The Duration Of The Operation</translate></el-button>
							</div>
						</div>
					</div>

					<el-tab-pane :label="attrText.overview" name="overview">
						<statisticsOverview :filter-params="summaryFilter" />
					</el-tab-pane>

					<el-tab-pane :label="attrText.team" name="company">
						<div v-loading="loading" v-show="loading" style="width: 100%; height: 300px"></div>
						<div class="chart-panel" v-if="!loading">
							<div class="total-chart chart" v-if="statistic.chart === 'connect'">
								<nvd3-line-chart v-if="statisticData.company.totalChartData" :options="statisticData.company.totalChartData.options" :data="statisticData.company.totalChartData.data"></nvd3-line-chart>
							</div>
							<el-row class="people-chart chart clearfix" :gutter="10">
								<div style="width: 100%; line-height: 220px; text-align: center" v-if="statistic.chart !== 'connect' && statisticData.company.peopleChartData ? !statisticData.company.peopleChartData.length : false">
									<translate>No Data</translate>
								</div>
								<el-col :xs="24" :sm="24" :md="12" :lg="12" class="people-chart-item" v-for="(chart, index) in statisticData.company.peopleChartData" :key="index">
									<div>
										<div class="chart-item-header text-center">
											<div class="photo">
												<img :src="chart.avatar | resetURL" border="0" />
											</div>
											<div class="name">
												<span>{{ chart.name }}</span>
												<span> ( {{ chart.account }} ) </span>
											</div>
										</div>
										<nvd3-line-chart :options="chart.options" :data="chart.data"></nvd3-line-chart>
									</div>
								</el-col>
							</el-row>
						</div>
					</el-tab-pane>
					<!--资源tab-->
					<el-tab-pane :label="attrText.resource" name="resource">
						<div v-loading="loading" v-show="loading" style="width: 100%; height: 300px"></div>
						<div class="chart-panel" v-if="!loading">
							<div class="chart bar-chart" v-if="statistic.chart === 'networkproject'">
								<div style="width: 100%; line-height: 220px; text-align: center" v-if="statisticData.resource.networkProject.data ? !statisticData.resource.networkProject.data[0].values.length : false">
									<translate>No Data</translate>
								</div>
								<nvd3-bar-chart v-if="statisticData.resource.networkProject.data ? statisticData.resource.networkProject.data[0].values.length : false" :options="statisticData.resource.networkProject.options" :data="statisticData.resource.networkProject.data"></nvd3-bar-chart>
							</div>
							<div v-if="statistic.chart !== 'networkproject'">
								<el-row class="people-chart chart bar-chart clearfix" :gutter="10">
									<div style="width: 100%; line-height: 220px; text-align: center" v-if="statisticData.resource.networkOrProject ? !statisticData.resource.networkOrProject.length : false">
										<translate>No Data</translate>
									</div>
									<el-col :xs="24" :sm="24" :md="12" :lg="12" class="people-chart-item" v-for="(chart, index) in statisticData.resource.networkOrProject" :key="index">
										<div>
											<div style="padding: 10px 10px 0 10px; width: 100%">
												<span>{{ chart.name }}</span>
											</div>
											<div style="width: 100%; margin-top: -10px; height: 220px; text-align: center; padding: 60px 0" v-if="!chart.hasData">
												<translate>No Data</translate>
											</div>
											<div v-if="chart.hasData" style="width: 100%; padding: 10px; margin-top: -10px; height: 220px; overflow-y: auto">
												<nvd3-bar-chart :options="chart.options" :data="chart.data"></nvd3-bar-chart>
											</div>
										</div>
									</el-col>
								</el-row>
							</div>
						</div>
					</el-tab-pane>
				</el-tabs>
			</div>
		</div>
	</div>
</template>

<script>
import statisticsOverview from './model/statistics-overview.vue'
import STORE_CONST from '../../store/consts'
import Nvd3PieChart from '../common/nvd3-pie-chart'
import Nvd3LineChart from '../common/nvd3-line-chart'
import Nvd3BarChart from '../common/nvd3-bar-chart'
import Echarts from '../common/echarts.vue'
import d3 from 'd3'
import ElCol from 'element-ui/packages/col/src/col'
import { Utils } from '../../config'
import moment from '../../../node_modules/moment'

export default {
	data() {
		return {
			activeTabName: this.$route.query.type || 'overview',
			loading: true,
			filterList: {
				memberList: [],
				workGroupList: [],
				clusterList: [],
				resourceList: [],
			},
			xAxis: [],
			statisticData: {
				company: {
					data: null,
					totalChartData: null,
					peopleChartData: null,
				},
				resource: {
					networkProject: null,
					networkOrProject: null,
				},
			},
			statistic: {
				type: 'overview',
				chart: 'connect',
				start: null,
				end: null,
				dataLen: 7,
			},
			filterTimes: [new Date(new Date().getTime() - 7 * 24 * 3600 * 1000), new Date()],
			summaryFilter: {
				time_from: Math.floor(new Date().getTime() / 1000) - 7 * 24 * 3600,
				time_end: Math.floor(new Date().getTime() / 1000),
				account_id: '',
				resource_type: '',
				network_id: '',
				project_id: '',
				resource_id: '',
			},
			pickerOptions: {
				shortcuts: [
					{
						text: '近一天',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24)
							picker.$emit('pick', [start, end])
						},
					},
					{
						text: '近7天',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
							picker.$emit('pick', [start, end])
						},
					},
					{
						text: '近30天',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
							picker.$emit('pick', [start, end])
						},
					},
				],
			},
		}
	},
	computed: {
		attrText() {
			return this.getTranslateText()
		},
		languageCurrent() {
			return this.$language.current
		},
		// 饼图数据（匹配图中“各类型13次、占比6%”）
		pieSeriesData() {
			const value = 13
			const percent = 6
			return [
				{ name: 'MySQL', value, percent },
				{ name: 'SQL server', value, percent },
				{ name: 'PostgreSQL', value, percent },
				{ name: 'Windows(RDP)', value, percent },
				{ name: 'Linux(SSH)', value, percent },
			]
		},
	},
	mounted() {
		this.routeChange(this.$route.query.type)
		this.getMemberList()
		this.getWorkGroupList()
		this.getClusterList()
		this.getResourceList()
		//      this.onChangeTab(null)
		console.log(location, 'location')
	},
	methods: {
		getTranslateText() {
			return {
				within7Day: this.$gettext('Within 7 Days'),
				within30Day: this.$gettext('Within 30 Days'),
				within90Day: this.$gettext('Within 90 Days'),
				team: this.$gettext('Team'),
				overview: this.$gettext('Overview'),
				resource: this.$gettext('Resource'),
				connectNum: this.$gettext('Number of Connections'),
				connectDur: this.$gettext('Duration of Connections'),
			}
		},
		getCompanyPeopleChartOptions(chartData) {
			const peopleChartData = []
			const chartOptions = {
				options: {
					chart: {
						showLegend: false,
						showControls: false,
						height: 250,
						showMinMaxPoints: false,
						margin: {
							top: 20,
							right: 30,
							bottom: 40,
							left: this.statistic.chart === 'connect' ? 40 : 80,
						},
						padding: {
							top: 20,
							right: 30,
							bottom: 30,
							left: 30,
						},
						x: (d) => d.x,
						y: (d) => d.y,
						useInteractiveGuideline: true,
						xAxis: {
							showMaxMin: false,
							tickFormat: (d, index) => {
								const date = new Date(this.xAxis[d])
								return date.getFullYear() + '.' + (date.getMonth() + 1) + '.' + date.getDate()
							},
						},
						yDomain: [0, 10],
						yAxis: {
							showMaxMin: false,
							tickFormat: (d) => {
								if (this.statistic.chart === 'connect' || d === 0) {
									return d
								} else {
									let timeStr = ''
									let hour = Math.floor(d / 3600)
									let minute = Math.floor((d - hour * 3600) / 60)
									let second = Math.floor(d % 60)
									timeStr += (hour < 10 ? '0' + hour : hour) + ':'
									timeStr += (minute < 10 ? '0' + minute : minute) + ':'
									timeStr += second < 10 ? '0' + second : second
									return timeStr
								}
							},
						},
					},
				},
				data: [],
			}
			chartData.forEach((item, index) => {
				let _maxValue = d3.max(item.results, (vItem) => {
					return vItem.y
				})
				let itemOptions = Object.clone(chartOptions)
				if (_maxValue > 10) {
					itemOptions.options.chart.yDomain = [0, _maxValue + Math.floor(_maxValue / 5)]
				}
				peopleChartData.push(
					Object.assign(
						{},
						item,
						Object.assign({}, itemOptions, {
							data: [
								{
									values: item.results,
									key: this.statistic.chart === 'connect' ? this.$gettext('The total number of connections') : this.$gettext('The total length of connections'),
									color: '#A2F1AF',
									area: true,
								},
							],
						}),
					),
				)
			})
			return peopleChartData
		},
		getCompanyTotalChartOptions(chartData) {
			const colors = ['#529AFC']
			let _maxValue = d3.max(chartData[0], (vItem) => {
				return vItem.y
			})
			const totalChartData = {
				options: {
					chart: {
						showLegend: false,
						showControls: false,
						showMinMaxPoints: false,
						height: 250,
						margin: {
							top: 20,
							right: 30,
							bottom: 40,
							left: this.statistic.chart === 'connect' ? 40 : 80,
						},
						x: (d) => d.x,
						y: (d) => d.y,
						useInteractiveGuideline: true,
						xAxis: {
							showMaxMin: false,
							tickFormat: (d, index) => {
								const date = new Date(this.xAxis[d])
								return date.getFullYear() + '.' + (date.getMonth() + 1) + '.' + date.getDate()
							},
						},
						yDomain: _maxValue > 10 ? [0, _maxValue + Math.floor(_maxValue / 5)] : [0, 10],
						yAxis: {
							showMaxMin: false,
							tickFormat: (d) => {
								if (this.statistic.chart === 'connect' || d === 0) {
									return d
								} else {
									let timeStr = ''
									let hour = Math.floor(d / 3600)
									let minute = Math.floor((d - hour * 3600) / 60)
									let second = Math.floor(d % 60)
									timeStr += (hour < 10 ? '0' + hour : hour) + ':'
									timeStr += (minute < 10 ? '0' + minute : minute) + ':'
									timeStr += second < 10 ? '0' + second : second
									return timeStr
								}
							},
						},
					},
				},
				data: [],
			}
			chartData.forEach((item, index) => {
				totalChartData.data.push({
					values: item,
					key: this.statistic.chart === 'connect' ? this.$gettext('The total number of connections') : this.$gettext('The total length of connections'),
					color: colors[index],
					area: true,
				})
			})
			return totalChartData
		},
		getNetworkProjectChartOptions(chartData) {
			const networkProjectChartData = {
				options: {
					chart: {
						showLegend: false,
						showControls: false,
						showValues: true,
						showYAxis: false,
						tooltip: {
							headerFormatter: (d) => {
								return d.replace(/-&#@#&-[0-9]*/g, '')
							},
						},
						valueFormat: (d) => d3.format(',f')(d),
						barColor: (d) => {
							if (d.label === 'others') {
								return '#FFD036'
							}
							return '#FF6472'
						},
						duration: 500,
						height: chartData.length * 40 < 200 ? 200 : chartData.length * 40,
						groupSpacing: 0.5,
						margin: {
							top: 20,
							right: 20,
							bottom: 40,
							left: 200,
						},
						x: (d) => {
							return d.label !== 'others' ? d.label : this.$gettext('others')
						},
						y: (d) => {
							return d.value
						},
						yAxis: {
							showMaxMin: false,
							tickFormat: (d) => d3.format(',f')(d),
						},
						xAxis: {
							showMaxMin: false,
							tickFormat: (d, x, y) => {
								if (x === undefined && y === undefined) {
									return d
								}
								let totalLen = 0
								if (d) {
									d = d.replace(/-&#@#&-[0-9]*/g, '')
									totalLen = d.length
								}
								let doubleByteChart = d.match(/[^\x00-\xff]/g)
								if (doubleByteChart) {
									totalLen = totalLen + doubleByteChart.length
								}
								let len = 0
								let str = ''
								for (let chart of d) {
									let _chart = chart.match(/[^\x00-\xff]/g)
									if (_chart && _chart.length > 0) {
										len += 2
									} else {
										len += 1
									}
									if (len <= 30) {
										str += chart
									} else {
										break
									}
								}
								if (len < totalLen) {
									str += '...'
								}
								return str
							},
						},
					},
				},
				data: [
					{
						key: this.$gettext('Number of Connections'),
						color: '#FF6472',
						values: chartData,
					},
				],
			}
			return networkProjectChartData
		},
		getNetworkOrProjectChartOptions(chartData) {
			const networkOrProjectChartData = []
			chartData.forEach((chartItem, index) => {
				const data = Object.clone(chartItem.data)
				chartItem.data = []
				chartItem.data.push({
					key: this.$gettext('Number of Connections'),
					color: '#FF6472',
					values: data,
				})
				chartItem = Object.assign({}, chartItem, {
					options: {
						chart: {
							showLegend: false,
							showControls: false,
							showValues: true,
							showYAxis: false,
							tooltip: {
								headerFormatter: (d) => {
									return d.replace(/-&#@#&-[0-9]*/g, '')
								},
							},
							valueFormat: (d) => d3.format(',f')(d),
							barColor: (d) => {
								if (d.label === 'others') {
									return '#FFD036'
								}
								return '#FF6472'
							},
							duration: 500,
							height: chartItem.dataLen * 50 <= 100 ? 150 : chartItem.dataLen * 50,
							groupSpacing: 0.5,
							margin: {
								top: 20,
								right: 20,
								bottom: 40,
								left: 100,
							},
							x: (d) => {
								return d.label !== 'others' ? d.label : this.$gettext('others')
							},
							y: (d) => {
								return d.value
							},
							yAxis: {
								showMaxMin: false,
								tickFormat: (d) => d3.format(',f')(d),
							},
							xAxis: {
								showMaxMin: false,
								tickFormat: (d, x, y) => {
									if (x === undefined && y === undefined) {
										return d
									}
									let totalLen = 0
									if (d) {
										d = d.replace(/-&#@#&-[0-9]*/g, '')
										totalLen = d.length
									}
									let doubleByteChart = d.match(/[^\x00-\xff]/g)
									if (doubleByteChart) {
										totalLen = totalLen + doubleByteChart.length
									}
									let len = 0
									let str = ''
									for (let chart of d) {
										let _chart = chart.match(/[^\x00-\xff]/g)
										if (_chart && _chart.length > 0) {
											len += 2
										} else {
											len += 1
										}
										if (len <= 10) {
											str += chart
										} else {
											break
										}
									}
									if (len < totalLen) {
										str += '...'
									}
									return str
								},
							},
						},
					},
				})
				networkOrProjectChartData.push(chartItem)
			})
			return networkOrProjectChartData
		},
		drawResourceChartData(data, type) {
			let chartData = []
			if (type === 'networkproject') {
				// v1版本
				for (let key in data) {
					data[key].forEach((item, index) => {
						chartData.push({
							label: `${key}(${item.name}-&#@#&-${item.id})`,
							value: item.conn_count,
						})
					})
				}
				chartData.sort((a, b) => {
					return b.value - a.value
				})
				/*
          // 旧版本
          data.forEach((item, index) => {
            chartData.push({
              label: item.project_resource_name,
              value: item.total
            })
          })
          */
			} else {
				// v1版本
				for (let key in data) {
					const hasData = data[key].length > 0
					const monitor = {
						name: key,
						hasData: hasData,
						dataLen: data[key].length,
						data: [],
					}
					data[key].forEach((item, index) => {
						monitor.data.push({
							label: `${item.name}-&#@#&-${item.id}`,
							value: item.conn_count,
						})
					})
					chartData.push(monitor)
				}
				/*
          // 旧版本
          data.forEach((item, index) => {
            Object.forEach(item, (vals, key) => {
              const hasData = vals.length > 0
              const monitor = {
                name: key,
                hasData: hasData,
                dataLen: vals.length,
                data: []
              }
              vals.forEach((valItem, index) => {
                monitor.data.push({
                  label: valItem.resource_name,
                  value: valItem.total
                })
              })
              chartData.push(monitor)
            })
          })
          */
			}
			return chartData
		},
		drawCompanyChartData(data, type) {
			let chartData = []
			if (type === 'total') {
				if (data) {
					let totalData = data.result
					totalData.forEach((item, index) => {
						item._time = new Date(item.date.replace(/-/g, '/') + ' 00:00:00').getTime()
						this.xAxis.push(item._time)
						chartData.push({
							x: index,
							xLabel: item._time,
							y: item.conn_count,
						})
					})
				}
				/*
          // 旧版本
          let totalData = data.company
          totalData.sort((a, b) => {
            return new Date(a.time.replace(/-/g, '/') + ' 00:00:00').getTime() - new Date(b.time.replace(/-/g, '/') + ' 00:00:00').getTime()
          })
          totalData.forEach((item, index) => {
            item._time = new Date(item.time.replace(/-/g, '/') + ' 00:00:00').getTime()
            this.xAxis.push(item._time)
            chartData.push({
              x: index,
              xLabel: item._time,
              y: item.value.total
            })
          })
          */
			} else {
				// v1版本
				if (data) {
					let peopleData = data.result
					for (let key in peopleData) {
						const _item = {
							account: peopleData[key]['account'],
							avatar: peopleData[key]['avatar'],
							name: key,
							results: [],
						}
						peopleData[key].days.forEach((resultItem, _index) => {
							_item.results.push({
								x: _index,
								xLabel: new Date(resultItem.date.replace(/-/g, '/') + ' 00:00:00').getTime(),
								y: this.statistic.chart === 'connect' ? resultItem.conn_count : resultItem.conn_time,
							})
						})
						chartData.push(_item)
					}
				}
				/*
          // 旧版本
          let peopleData = this.statistic.chart === 'connect' ? data.account['total'] : data.account['time_long']
          peopleData.forEach((item, index) => {
            const _item = {
              account: item.account,
              name: item.name,
              avatar: item.avatar,
              results: []
            }
            item.results.sort((a, b) => {
              return new Date(a.time.replace(/-/g, '/') + ' 00:00:00').getTime() - new Date(b.time.replace(/-/g, '/') + ' 00:00:00').getTime()
            })
            item.results.forEach((resultItem, _index) => {
              _item.results.push({
                x: _index,
                xLabel: new Date(resultItem.time.replace(/-/g, '/') + ' 00:00:00').getTime(),
                y: this.statistic.chart === 'connect' ? resultItem.value.total : resultItem.value.time_long
              })
            })
            chartData.push(_item)
          })
          */
			}
			return chartData
		},
		// 获取团队监控信息
		// 获取团队成员一段时间内的连接统计
		getCompanyStatistic(_start, _end) {
			return new Promise((resolve, reject) => {
				if (!this.statisticData.company.data) {
					let params = {
						time_from: _start,
						time_end: _end,
					}
					this.$store.dispatch(STORE_CONST.TEAM.GET_STATISTIC_TEAM, params).then((res) => {
						this.statisticData.company.data = res
						resolve({ data: res })
					})
				} else {
					resolve(this.statisticData.company.data)
				}
			})
		},
		// 获取团队所有资源一段时间内的连接统计
		getCompanyTotalStatistic(_start, _end) {
			return new Promise((resolve, reject) => {
				if (!this.statisticData.company.totalData) {
					let params = {
						time_from: _start,
						time_end: _end,
					}
					this.$store.dispatch(STORE_CONST.TEAM.GET_RESOURCE_STATISTIC_TEAM, params).then((res) => {
						this.statisticData.company.totalData = res
						resolve({ data: res })
					})
				} else {
					resolve(this.statisticData.company.totalData)
				}
			})
		},
		// 获取全部资源的监控信息
		getClusterResourceStatistic(_start, _end) {
			return new Promise((resolve, reject) => {
				let params = {
					time_from: _start,
					time_end: _end,
				}
				this.$store.dispatch(STORE_CONST.CLUSTER.GET_CLUSTER_RESOURCE_STATISTIC, params).then(
					(res) => {
						this.statisticData.resource.networkProject = res.result
						resolve({ data: res })
					},
					() => {
						this.statisticData.resource.networkProject = null
						resolve({ err: 1 })
					},
				)
			})
		},
		// 获取集群的监控信息
		getClusterStatistic(_start, _end) {
			return new Promise((resolve, reject) => {
				let params = {
					time_from: _start,
					time_end: _end,
				}
				this.$store.dispatch(STORE_CONST.CLUSTER.GET_CLUSTER_STATISTIC, params).then(
					(res) => {
						this.statisticData.resource.networkOrProject = res.result
						resolve({ data: res })
					},
					() => {
						this.statisticData.resource.networkOrProject = null
						resolve({ err: 1 })
					},
				)
			})
		},
		// 获取资源的监控信息
		getResourceStatistic(_start, _end) {
			return new Promise((resolve, reject) => {
				let params = {
					time_from: _start,
					time_end: _end,
				}
				this.$store.dispatch(STORE_CONST.CLUSTER.GET_RESOURCE_STATISTIC, params).then(
					(res) => {
						this.statisticData.resource.networkOrProject = res.result
						resolve({ data: res })
					},
					() => {
						this.statisticData.resource.networkOrProject = null
						resolve({ err: 1 })
					},
				)
			})
		},
		getStatisticInitTime() {
			let dataLen = this.statistic.dataLen
			let currentDate = new Date()
			let year = currentDate.getFullYear()
			let month = currentDate.getMonth() + 1 < 10 ? '0' + (currentDate.getMonth() + 1) : '' + (currentDate.getMonth() + 1)
			let date = currentDate.getDate() < 10 ? '0' + currentDate.getDate() : currentDate.getDate()
			let endDate = new Date(year + '/' + month + '/' + date + ' 23:59:59')
			let startDate = new Date(endDate.getTime() - (dataLen * 24 * 60 * 60 * 1000 - 1000))
			this.statistic.start = Math.floor(startDate.getTime() / 1000)
			this.statistic.end = Math.floor(endDate.getTime() / 1000)
		},
		onChangeTab(_tab) {
			this.$router.push({ name: 'statistics', query: { type: _tab.name } })
			this.activeTabName = this.$route.query.type || 'overview'
			this.loading = true
			this.statistic.type = _tab.name || 'overview'
		},
		// route Pramas
		routeChange(type) {
			this.statistic.dataLen = 7
			this.statistic.type = this.activeTabName
			this.getStatisticInitTime()
			if (type === 'company') {
				this.statistic.chart = 'connect'
				this.getCompanyStatistic(this.statistic.start, this.statistic.end).then((data) => {
					if (!data.err) {
						// const totalChartData = this.drawCompanyChartData(this.statisticData.company.data, 'total')
						const peopleChartData = this.drawCompanyChartData(this.statisticData.company.data, 'people')
						// this.statisticData.company.totalChartData = this.getCompanyTotalChartOptions([totalChartData])
						this.statisticData.company.peopleChartData = this.getCompanyPeopleChartOptions(peopleChartData)
					}
					this.loading = false
				})
				this.getCompanyTotalStatistic(this.statistic.start, this.statistic.end).then((data) => {
					if (!data.err) {
						const totalChartData = this.drawCompanyChartData(this.statisticData.company.totalData, 'total')
						this.statisticData.company.totalChartData = this.getCompanyTotalChartOptions([totalChartData])
					}
					this.loading = false
				})
			} else {
				this.statistic.chart = 'networkproject'
				this.getClusterResourceStatistic(this.statistic.start, this.statistic.end).then((data) => {
					if (!data.err) {
						const networkProjectData = this.drawResourceChartData(this.statisticData.resource.networkProject, 'networkproject')
						this.statisticData.resource.networkProject = this.getNetworkProjectChartOptions(networkProjectData)
					}
					this.loading = false
				})
			}
		},
		onChangeChart(_chart) {
			this.statistic.chart = _chart
			if (this.statistic.type === 'company') {
				this.getCompanyStatistic(this.statistic.start, this.statistic.end).then((data) => {
					if (!data.err) {
						// const totalChartData = this.drawCompanyChartData(this.statisticData.company.data, 'total')
						const peopleChartData = this.drawCompanyChartData(this.statisticData.company.data, 'people')
						// this.statisticData.company.totalChartData = this.getCompanyTotalChartOptions([totalChartData])
						this.statisticData.company.peopleChartData = this.getCompanyPeopleChartOptions(peopleChartData)
					}
					this.loading = false
				})
				this.getCompanyTotalStatistic(this.statistic.start, this.statistic.end).then((data) => {
					if (!data.err) {
						const totalChartData = this.drawCompanyChartData(this.statisticData.company.totalData, 'total')
						this.statisticData.company.totalChartData = this.getCompanyTotalChartOptions([totalChartData])
					}
					this.loading = false
				})
			} else {
				this.loading = true
				if (this.statistic.chart === 'networkproject') {
					this.getClusterResourceStatistic(this.statistic.start, this.statistic.end).then((data) => {
						if (!data.err) {
							const networkProjectData = this.drawResourceChartData(this.statisticData.resource.networkProject, 'networkproject')
							this.statisticData.resource.networkProject = this.getNetworkProjectChartOptions(networkProjectData)
						}
						this.loading = false
					})
				} else if (this.statistic.chart === 'network') {
					this.getClusterStatistic(this.statistic.start, this.statistic.end).then((data) => {
						if (!data.err) {
							const networkData = this.drawResourceChartData(this.statisticData.resource.networkOrProject, 'network')
							this.statisticData.resource.networkOrProject = this.getNetworkOrProjectChartOptions(networkData)
						}
						this.loading = false
					})
				} else if (this.statistic.chart === 'project') {
					this.getResourceStatistic(this.statistic.start, this.statistic.end).then((data) => {
						if (!data.err) {
							const projectData = this.drawResourceChartData(this.statisticData.resource.networkOrProject, 'project')
							this.statisticData.resource.networkOrProject = this.getNetworkOrProjectChartOptions(projectData)
						}
						this.loading = false
					})
				}
			}
		},
		onChangeDateLen() {
			this.loading = true
			this.getStatisticInitTime()
			this.xAxis = []
			if (this.statistic.type === 'company') {
				this.statisticData.company.data = null
				this.statisticData.company.totalData = null
				this.getCompanyStatistic(this.statistic.start, this.statistic.end).then((data) => {
					if (!data.err) {
						// const totalChartData = this.drawCompanyChartData(this.statisticData.company.data, 'total')
						const peopleChartData = this.drawCompanyChartData(this.statisticData.company.data, 'people')
						// this.statisticData.company.totalChartData = this.getCompanyTotalChartOptions([totalChartData])
						this.statisticData.company.peopleChartData = this.getCompanyPeopleChartOptions(peopleChartData)
					}
					this.loading = false
				})
				this.getCompanyTotalStatistic(this.statistic.start, this.statistic.end).then((data) => {
					if (!data.err) {
						const totalChartData = this.drawCompanyChartData(this.statisticData.company.totalData, 'total')
						this.statisticData.company.totalChartData = this.getCompanyTotalChartOptions([totalChartData])
					}
				})
			} else {
				if (this.statistic.chart === 'networkproject') {
					this.getClusterResourceStatistic(this.statistic.start, this.statistic.end).then((data) => {
						if (!data.err) {
							const networkProjectData = this.drawResourceChartData(this.statisticData.resource.networkProject, 'networkproject')
							this.statisticData.resource.networkProject = this.getNetworkProjectChartOptions(networkProjectData)
						}
						this.loading = false
					})
				} else if (this.statistic.chart === 'network') {
					this.getClusterStatistic(this.statistic.start, this.statistic.end).then((data) => {
						if (!data.err) {
							const networkData = this.drawResourceChartData(this.statisticData.resource.networkOrProject, 'network')
							this.statisticData.resource.networkOrProject = this.getNetworkOrProjectChartOptions(networkData)
						}
						this.loading = false
					})
				} else if (this.statistic.chart === 'project') {
					this.getResourceStatistic(this.statistic.start, this.statistic.end).then((data) => {
						if (!data.err) {
							const projectData = this.drawResourceChartData(this.statisticData.resource.networkOrProject, 'project')
							this.statisticData.resource.networkOrProject = this.getNetworkOrProjectChartOptions(projectData)
						}
						this.loading = false
					})
				}
			}
		},
		changeTimes() {
			this.summaryFilter.time_from = moment(this.filterTimes[0]).unix()
			this.summaryFilter.time_end = moment(this.filterTimes[1]).endOf('day').unix()
			console.log(moment(this.filterTimes[0]).format('YYYY-MM-DD HH:mm:ss'), moment(this.filterTimes[1]).format('YYYY-MM-DD HH:mm:ss'))
			console.log(moment(this.summaryFilter.time_from * 1000).format('YYYY-MM-DD HH:mm:ss'), moment(this.summaryFilter.time_end * 1000).format('YYYY-MM-DD HH:mm:ss'))
		},
		// 导出按钮点击事件
		handleExport() {
			let paramsStr = ''
			for (let k in this.summaryFilter) {
				paramsStr += `${k}=${this.summaryFilter[k]}&`
			}
			window.open(`${location.origin}${location.pathname}#exportOverview/?${paramsStr}`, '_blank')
			// this.$router.push({ name: 'exportOverview', query: { ...this.summaryFilter } })
		},

		// 获取成员列表
		getMemberList() {
			let params = {
				page: 1,
				page_size: Utils.config.maxPageSize,
			}
			this.$store.dispatch(STORE_CONST.TEAM.GET_MEMBER_LIST, { params: params }).then((res) => {
				this.filterList.memberList = res.objects
			})
		},
		// 获取工作组列表
		getWorkGroupList() {
			let params = {
				page: 1,
				page_size: Utils.config.maxPageSize,
			}
			this.$store.dispatch(STORE_CONST.WORKGROUP.LIST_WORKGROUP, params).then((res) => {
				this.filterList.workGroupList = res.objects
			})
		},

		// 获取集群列表
		getClusterList() {
			let params = {
				page: 1,
				page_size: Utils.config.maxPageSize,
			}
			this.$store.dispatch(STORE_CONST.CLUSTER.GET_CLUSTER, params).then((res) => {
				this.filterList.clusterList = res.objects
			})
		},

		// 获取资源列表
		getResourceList() {
			let params = {
				page: 1,
				page_size: Utils.config.maxPageSize,
			}
			this.$store.dispatch(STORE_CONST.CLUSTER.GET_RESOURCE_LISTS, params).then((res) => {
				this.filterList.resourceList = res.objects
			})
		},
	},
	watch: {
		$route(to, from) {
			this.activeTabName = this.$route.query.type
			this.routeChange(this.$route.query.type)
		},
		languageCurrent: function (newVal, oldVal) {
			this.routeChange(this.$route.query.type)
		},
	},
	components: {
		ElCol,
		Nvd3PieChart,
		Nvd3LineChart,
		Nvd3BarChart,
		Echarts,
		statisticsOverview,
	},
}
</script>

<style lang="scss" rel="stylesheet/scss">
.app-content .view-content {
	padding: 0;
}
.panel {
	.panel-header {
		border-bottom: 1px solid #ddd;
		padding: 15px 15px;
		background: #fff;
		line-height: 32px;
		.panel-search {
			position: relative;
			float: right;
			.dropdown {
				float: left;
				min-width: 120px;
			}
		}
	}
}
.chart-panel {
	background: #fff;
	.chart path.nv-point {
		fill: #fff;
		fill-opacity: 1 !important;
		stroke-opacity: 1 !important;
	}
	.chart path.nv-point.hover {
		fill: none !important;
	}

	.chart .nv-x .tick line {
		display: none;
	}
	.chart .nvd3 .nv-axis path {
		fill: none;
		stroke: #ccc;
		stroke-opacity: 0.75;
		shape-rendering: crispEdges;
	}
	.chart .nvd3 .nv-axis .nv-axisMaxMin text {
		font-weight: normal;
	}
	.chart .nv-interactiveGuideLine line {
		stroke: #529afc;
		fill: none;
		stroke-dasharray: 5, 3;
		stroke-width: 1;
	}

	.chart {
		.nv-y.nv-axis {
			.nv-zeroLine line {
				opacity: 0;
			}
		}
	}

	.chart.bar-chart {
		.nvd3 .nv-axis path {
			display: none;
		}
	}
	.nvd3 .nv-y.nv-axis .nv-zeroLine line {
		opacity: 0;
	}
	.nvd3 .nv-axis .zero line,
	.nvd3 .nv-axis line.zero {
		stroke-opacity: 0;
	}
	.nvd3 .nv-discretebar .nv-groups text,
	.nvd3 .nv-multibarHorizontal .nv-groups text,
	.nvd3.nv-axis .nv-axisMaxMin text {
		font-weight: 400 !important;
	}
	.total-chart {
		height: 250px;
		width: 100%;
	}
	.people-chart {
		.people-chart-item {
			float: left;
			/*width: 50%;*/
			padding: 5px;
			> div {
				border: 1px solid #ddd;
				padding: 10px;
				height: 360px;
				.chart-item-header {
					.photo {
						> img {
							width: 64px;
							height: 64px;
							border-radius: 50%;
							border: 0;
						}
					}
				}
			}
		}
	}
}

/* 筛选栏 */
.filter-bar {
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 12px;
	.filter-label {
		color: #666;
		white-space: nowrap;
		margin-right: 5px;
	}
	.filter-select {
		width: 150px;
		border-radius: 2px;
		font-size: 12px;
	}
}

.resource-select {
	.el-select-dropdown__item {
		height: 55px;
		p {
			&:first-child {
				font-weight: 700;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// statistics.vue?4b7e7f5e